<template>
    <div class="container demo" id="demo">
        <div class="row">
            <div class="col-12 text-center">
                <h1>Movie Search from OMDB API Using Axios</h1>
                <hr>
                    <input type="text" class="form-control mb-3 text-center" id="movie" aria-describedby="emailHelp">
                    <button class="btn btn-primary mb-3 btn-lg mx-2" v-on:click="showData()">Search</button>
                    <button class="btn btn-primary mb-3 btn-lg" v-on:click="clear()">Clear</button>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 d-flex justify-content-center" v-for="item in info" v-bind:key="item.imdbID">
                <div class="card mb-3">
                    <img :src="item.Poster" class="card-img-top" :alt="item.Title">
                    <div class="card-body">
                        <h5 class="card-title">{{item.Title}}</h5>
                        <p class="card-text">{{item.Type}}</p>
                        <p class="card-text">{{item.Year}}</p>
                        <a href="#" class="btn btn-primary">Go somewhere</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: 'Demo',
    data() {
        return {
            info: null,
            loading: true,
            errored: false,
        }
    },
    methods: {
        getValue() {
            let value = document.getElementById("movie").value;
            return value
        },
        showData() {
            axios
                .get(`https://www.omdbapi.com/?apikey=dc01b00b&s=${this.getValue()}`)
                .then(response => (this.info = response.data.Search
                ))
                .catch(error => {
                    console.log(error)
                    this.errored = true
                })
                .finally(() => this.loading = false)
        },
        clear() {
            axios
                .get(`https://www.omdbapi.com/?apikey=dc01b00b&s=`)
                .then(response => (this.info = response.data.Search))
        }
    }
}
</script>  

<style lang="scss" scoped>
.container {
    margin-top: 5% 0%;
    .row  {
        margin-top: 10%;
    }
    .card {
        width: 18rem;
        img {
            height: 396px;
        }
    }
}
</style>
